// src/actions/tagActions.js

import { axiosInstance } from "../axios/privateAxios"
import {
    TAG_ERROR,
    GET_TAGS,
    SET_TAG_FETCHING
} from "./tagTypes"

export const getTags = () => async dispatch => {
    dispatch({type: SET_TAG_FETCHING, payload: true})
    try{
        const response = await axiosInstance.get(`/users/tags`)
        dispatch({type: GET_TAGS, payload: response.data})
        dispatch({type: SET_TAG_FETCHING, payload: false})
    }
    catch(err){
        dispatch({type: TAG_ERROR})
        dispatch({type: SET_TAG_FETCHING, payload: false})
    }
}